export default "__VITE_ASSET__KPYBjf1Y__"